module.exports = __webpack_public_path__ + "418bf75b439f38c8d3d21b6482582cdc.jpg";